function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import MenuItems from './menu-items';
import PubSub from 'pubsub-js';
import account from '../data/account';
import { docsForPath } from '../data/docs-links';

/*
 * Desktop sidebar — §366: a collapsed 64px icon rail (one icon per domain group
 * + Home, in a single vertical column). CLICK a group icon and the sidebar
 * expands into a second column showing ONLY that group's submenu; click the
 * same icon again (or the backdrop, or pick an item) to collapse back to the
 * rail. Open-group state lives here so it can widen .app-sidebar and render the
 * click-away backdrop; MenuItems gets it via props.
 */
export default class AppSidebar extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      openGroup: null
    });
    _defineProperty(this, "toggleGroup", key => this.setState(s => ({
      openGroup: s.openGroup === key ? null : key
    })));
    _defineProperty(this, "closeGroup", () => {
      if (this.state.openGroup) this.setState({
        openGroup: null
      });
    });
  }
  componentDidMount() {
    document.body.classList.add('nav-rail');
  }
  componentWillUnmount() {
    document.body.classList.remove('nav-rail');
  }
  render() {
    var accountModel = account.get() || {};
    const whiteLabel = !!(accountModel.whiteLabel && accountModel.company);
    var title = whiteLabel ? accountModel.company.toUpperCase() : 'PLUNK';
    const expanded = !!this.state.openGroup;
    // Logo: Plunk uses the official wordmark (PlunkDocs/branding/
    // plunk-wordmark.svg, inlined so it needs no separate asset deploy) — the
    // SAME svg both collapsed and expanded (CSS crops it to just the "P" when
    // collapsed, so the mark matches the wordmark's letters exactly). White-
    // label tenants keep their company name as text (mark + full spans).
    const plunkLogo = /*#__PURE__*/React.createElement("svg", {
      className: "logo-plunk",
      viewBox: "0 0 1744 274",
      preserveAspectRatio: "xMinYMid meet",
      role: "img",
      "aria-label": "Plunk"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "translate(6.2,267.250786) scale(0.1,-0.1)",
      fill: "#141413",
      stroke: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M10 1315 l0 -1285 185 0 185 0 0 390 0 390 393 0 c424 0 506 7 671 55 328 95 544 309 618 610 31 127 31 333 0 460 -87 353 -372 587 -794 649 -87 13 -209 16 -682 16 l-576 0 0 -1285z m1180 950 c276 -42 448 -175 505 -391 21 -79 21 -259 0 -338 -59 -223 -246 -361 -535 -396 -46 -5 -241 -10 -432 -10 l-348 0 0 575 0 575 358 0 c261 0 383 -4 452 -15z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3720 1315 l0 -1285 885 0 885 0 0 160 0 160 -695 0 -695 0 0 1125 0 1125 -190 0 -190 0 0 -1285z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M6942 1778 c4 -738 6 -833 22 -918 87 -466 341 -737 781 -835 113 -25 368 -31 505 -11 267 40 482 151 626 324 100 121 164 257 212 452 l26 105 3 853 4 852 -180 0 -180 0 -4 -832 c-4 -906 -2 -874 -62 -1034 -74 -196 -225 -329 -430 -381 -110 -27 -364 -25 -470 5 -233 67 -374 217 -447 477 -22 80 -23 85 -26 923 l-3 842 -190 0 -190 0 3 -822z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10970 1315 l0 -1285 190 0 190 0 2 950 3 950 764 -950 764 -950 154 0 153 0 0 1285 0 1285 -185 0 -185 0 -2 -953 -3 -954 -765 951 -765 951 -158 3 -157 3 0 -1286z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15060 1315 l0 -1285 185 0 185 0 0 333 1 332 234 240 c128 132 235 238 238 235 2 -3 223 -260 491 -573 l487 -567 215 0 c141 0 213 3 209 10 -3 6 -265 323 -581 706 l-575 697 24 26 c31 34 955 1011 1021 1079 l50 52 -211 0 -212 0 -693 -715 -693 -714 -3 714 -2 715 -185 0 -185 0 0 -1285z"
    })));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "app-sidebar rail" + (expanded ? " expanded" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "sidebar-toolbar"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "pointer primary",
      "data-logo": true
    }, whiteLabel ? /*#__PURE__*/React.createElement("span", {
      className: "logo-full"
    }, title) : plunkLogo)), /*#__PURE__*/React.createElement("div", {
      className: "sidebar-scrollable-container"
    }, /*#__PURE__*/React.createElement(MenuItems, {
      openGroup: this.state.openGroup,
      onToggleGroup: this.toggleGroup,
      onNavigate: this.closeGroup
    })), /*#__PURE__*/React.createElement("div", {
      className: "sidebar-bottom"
    }, /*#__PURE__*/React.createElement("a", {
      role: "button",
      tabIndex: 0,
      title: "Ask Plunk",
      "aria-label": "Ask Plunk",
      id: "assistant-icon",
      onClick: () => {
        this.closeGroup();
        PubSub.publish('plunk-assistant-toggle', {});
      },
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          PubSub.publish('plunk-assistant-toggle', {});
        }
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "auto_awesome")), /*#__PURE__*/React.createElement("a", {
      href: docsForPath(window.location.pathname),
      target: "_blank",
      rel: "noreferrer",
      title: "Help for this page (docs.plunk.io)",
      "aria-label": "Help for this page, opens docs.plunk.io",
      onClick: e => {
        e.currentTarget.href = docsForPath(window.location.pathname);
        this.closeGroup();
      }
    }, /*#__PURE__*/React.createElement("svg", {
      className: "rail-help-ic",
      viewBox: "0 0 24 24",
      width: "22",
      height: "22",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 17h.01"
    }))))), expanded && /*#__PURE__*/React.createElement("div", {
      className: "nav-rail-backdrop",
      onClick: this.closeGroup
    }));
  }
}